import { render } from "./StoreClaimDetails.vue?vue&type=template&id=26864dda"
import script from "./StoreClaimDetails.vue?vue&type=script&lang=js"
export * from "./StoreClaimDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__